<template>
  <div :class="showPageDialog?'page-dialog show':'page-dialog hide'">
    <h6 class="page-title">pages</h6>
    <ul class="page-content" v-if="clickName === 'touchstart'">
      <li v-for="(item,i) in totalPage" :key="i" @touchstart="chooseCurPage(item)">
        <span :class="curIdx===i?'active':''">{{item}}</span>
      </li>
    </ul>
    <ul class="page-content" v-else>
      <li v-for="(item,i) in totalPage" :key="i" @click="chooseCurPage(item)">
        <span :class="curIdx===i?'active':''">{{item}}</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    showPageDialog: {
      default() {
        return false
      },
      required: false
    },
    totalPage: {
      default() {
        return 1
      },
      required: true
    },
    clickName: {
      default() {
        return 'touchstart'
      },
      required: false
    }
  },
  data() {
    return {
      curIdx: 0
    }
  },
  methods: {
    chooseCurPage(curPage) {
      this.curIdx = curPage - 1
      this.$emit('handleChangePage', curPage - 1)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../scss/rem.scss';
.page-dialog {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 95%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  min-height: rem(160px);
  background: #fff;
  box-shadow: rem(2px) rem(2px) rem(5px) #eee;
  border-radius: rem(5px);
  transition: bottom 0.3s linear;
  > .page-title {
    height: rem(50px);
    line-height: rem(50px);
    font-size: rem(15px);
    font-weight: 600;
    text-align: center;
  }
  > .page-content {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    > li {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 20%;
      cursor: pointer;

      > span {
        width: rem(20px);
        height: rem(20px);
        line-height: rem(20px);
        text-align: center;
        font-size: rem(12px);
        &.active {
          border-radius: 50%;
          background: #008adb;
          color: #fff;
        }
      }
    }
  }
}
.show {
  bottom: rem(60px);
}
.hide {
  display: none;
  bottom: rem(-999px);
}
</style>